import { SurveyResultsSeeMoreDialog } from './components/dialogs/survey-results-seemore-dialog';
import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTranslateModule } from '../app/shared-translate.module';
import { MatTabsModule } from '@angular/material';
import { PipesModule } from './pipes.module';
import { CompareSurveyResultsComponent } from './components/dialogs/compare-survey-results.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
      CommonModule,
      SharedTranslateModule,
      MatTabsModule,
      PipesModule,
      MatCheckboxModule,
      FormsModule,
      MatTooltipModule,
    MatIconModule
    ],  
    declarations: [
        SurveyResultsSeeMoreDialog,
        CompareSurveyResultsComponent
    ],
    entryComponents: [
        SurveyResultsSeeMoreDialog,
        CompareSurveyResultsComponent
        ], 
    exports: [
        SurveyResultsSeeMoreDialog,
        CompareSurveyResultsComponent
    ]
})
  
export class SurveyResultsSeeMoreDialogModule {}
